import { render, staticRenderFns } from "./b-login.vue?vue&type=template&id=45886391&scoped=true&"
import script from "./b-login.vue?vue&type=script&lang=js&"
export * from "./b-login.vue?vue&type=script&lang=js&"
import style0 from "./b-login.vue?vue&type=style&index=0&id=45886391&lang=scss&scoped=true&"
import style1 from "./b-login.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45886391",
  null
  
)

export default component.exports